import template from './periodListMobile.html';
import controller from './periodListMobile.controller';
import './periodListMobile.scss';

let periodListMobileComponent = {
  restrict: 'E',
  bindings: {
    userInceptionId: '<',
    dateToLoad: '<'
  },
  template,
  controller
};

export default periodListMobileComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/periodListMobile/periodListMobile.component.js